module.exports = __webpack_public_path__ + "img/Card1.76b6980e.jpg";